export default "__VITE_ASSET__CwM2SCuc__"